import React, { FC } from "react";
import { Trans } from "react-i18next";

import { Anchor } from "@/components/Anchor";
import { Flex } from "@/eworkitComponents";
import { router } from "@/views/router";

import "./_public-attachments-list.scss";

export interface IPublicAttachmentsListProps {}

export const PublicAttachmentsList: FC<IPublicAttachmentsListProps> = () => {
  const baseClass = "public-attachments-list";

  return (
    <Flex className={baseClass} padding={["md"]} justify="center" align="center" wrap="wrap">
      <Trans ns="public" i18nKey="LANDING_PAGE.JOB_REQUEST.ATTACHMENTS.AUTHENTICATION_NEEDED">
        <Anchor href={router.get("register-form").path} />
        <Anchor href={router.get("login").path} />
      </Trans>
    </Flex>
  );
};
